import type { ProLayoutProps } from '@ant-design/pro-components';
import { BizAppConfig } from './application.manifest';
import { getBrandAppName } from './brand';

// Banner and sidebar share a palette while the content theme changes.
export function getNavigationToken(dark = false): ProLayoutProps['token'] {
  const background = dark ? '#1E1E1E' : '#f0f0f3';
  const text = dark ? 'rgba(255,255,255,0.88)' : '#1f2633';
  const muted = dark ? 'rgba(255,255,255,0.65)' : '#667085';
  const hover = dark ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.04)';
  const selected = dark ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.06)';
  return {
    header: {
      heightLayoutHeader: 44,
      colorBgHeader: background,
      colorBgScrollHeader: background,
      colorHeaderTitle: text,
      colorTextMenu: muted,
      colorTextMenuSecondary: muted,
      colorTextMenuSelected: text,
      colorTextMenuActive: text,
      colorBgMenuItemHover: hover,
      colorBgMenuItemSelected: 'transparent',
      colorBgMenuElevated: background,
      colorTextRightActionsItem: text,
      colorBgRightActionsItemHover: 'transparent',
    },
    sider: {
      colorMenuBackground: background,
      colorTextMenu: muted,
      colorTextMenuTitle: text,
      colorTextMenuSelected: text,
      colorTextMenuItemHover: text,
      colorBgMenuItemHover: hover,
      colorBgMenuItemSelected: selected,
      colorBgMenuItemCollapsedElevated: background,
      colorBgCollapsedButton: background,
      colorTextCollapsedButton: muted,
      colorTextCollapsedButtonHover: text,
    },
  };
}

/**
 * @name
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  navTheme: 'realDark',
  colorPrimary: '#1677ff',
  layout: 'mix',
  contentWidth: 'Fluid',
  fixedHeader: true,
  fixSiderbar: true,
  pwa: true,
  title: getBrandAppName(),
  logo: BizAppConfig.appLogo,
  token: getNavigationToken(true),
  splitMenus: true,
  siderWidth: 208,
};
export default Settings;
